import type {
    CurrencyPrice,
    PriceBandRow,
    PricePeriods,
} from "app/shared/model/EditPricelist";
import { normIso } from "../currency/normalizeCurrency";
import { normalizeDate } from "../date/iso";

export const toInt = (v: any) => {
    const n = typeof v === "number" ? v : Number(String(v ?? "").trim());
    return Number.isFinite(n) ? Math.trunc(n) : 0;
};

export const toDec = (v: any) => {
    const n = typeof v === "number" ? v : Number(String(v ?? "").trim());
    return Number.isFinite(n) ? n : 0;
};

const sanitizePrice = (price: any): CurrencyPrice => ({
    currencyIsoCode: normIso(price?.currencyIsoCode ?? ""),
    pricePerMajorUnit: toDec(price?.pricePerMajorUnit),
    pricePerMinorUnit: toDec(price?.pricePerMinorUnit),
});

export const sanitizeBand = (pb: any): PriceBandRow => ({
    minUnits: toInt(pb?.minUnits ?? pb?.MinUnits),
    maxUnits: toInt(pb?.maxUnits ?? pb?.MaxUnits),
    prices: Array.isArray(pb?.prices)
        ? pb.prices.map(sanitizePrice)
        : [],
});

export const sanitizePeriod = (pp: any): PricePeriods => ({
    startDate: normalizeDate(pp?.startDate ?? pp?.StartDate) as any,
    endDate: normalizeDate(pp?.endDate ?? pp?.EndDate) as any,
    priceBandStrategyId: toInt(pp?.priceBandStrategyId ?? pp?.PriceBandStrategyId),
    priceBands: Array.isArray(pp?.priceBands ?? pp?.PriceBands)
        ? (pp.priceBands ?? pp.PriceBands).map(sanitizeBand)
        : [],
});
